/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S5_Li1Inputs */

const tr_onbilgi_s5_li1 = /** @type {(inputs: Onbilgi_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kart ile ödemede abonelik, ödeme onayının ardından anında aktif hale gelir; havale/EFT ile ödemede bedelin Sağlayıcı hesabına ulaşmasının ardından en geç 1 (bir) iş günü içinde aktif edilir.`)
};

const en_onbilgi_s5_li1 = /** @type {(inputs: Onbilgi_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With card payment the subscription becomes active immediately after payment confirmation; with bank transfer/EFT it is activated no later than 1 (one) business day after the amount has reached the Provider's account.`)
};

const de_onbilgi_s5_li1 = /** @type {(inputs: Onbilgi_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei Kartenzahlung wird das Abonnement unmittelbar nach der Zahlungsbestätigung aktiv; bei Überweisung/EFT wird es spätestens 1 (einen) Werktag nach Eingang des Betrags auf dem Konto des Anbieters aktiviert.`)
};

const ru_onbilgi_s5_li1 = /** @type {(inputs: Onbilgi_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При оплате картой подписка активируется сразу после подтверждения платежа; при переводе/EFT она активируется не позднее 1 (одного) рабочего дня после поступления суммы на счёт Поставщика.`)
};

/**
* | output |
* | --- |
* | "With card payment the subscription becomes active immediately after payment confirmation; with bank transfer/EFT it is activated no later than 1 (one) busine..." |
*
* @param {Onbilgi_S5_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s5_li1 = /** @type {((inputs?: Onbilgi_S5_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S5_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s5_li1(inputs)
	if (locale === "de") return de_onbilgi_s5_li1(inputs)
	if (locale === "ru") return ru_onbilgi_s5_li1(inputs)
	return tr_onbilgi_s5_li1(inputs)
});